var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"mt-8"},[_c('v-btn',{attrs:{"color":"accent","depressed":"","large":"","block":""},on:{"click":function($event){return _vm.connect()}}},[_vm._v(" Connect Wallet ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }